import { defineMessages } from 'react-intl';

const _default_1: {
	readonly fileUploadButtonLabel: {
		readonly id: 'rovo-chat.file-upload-button.label';
		readonly defaultMessage: 'Upload file';
		readonly description: 'Label for the file upload button in the chat input';
	};
	readonly fileUploadButtonMaxFilesLabel: {
		readonly id: 'rovo-chat.file-upload-button.max-files-label';
		readonly defaultMessage: 'Limit of {maxFiles, plural, one {# file} other {# files}} reached';
		readonly description: 'Label for the file upload button in the chat input when max files is set';
	};
} = defineMessages({
	fileUploadButtonLabel: {
		id: 'rovo-chat.file-upload-button.label',
		defaultMessage: 'Upload file',
		description: 'Label for the file upload button in the chat input',
	},
	fileUploadButtonMaxFilesLabel: {
		id: 'rovo-chat.file-upload-button.max-files-label',
		defaultMessage: 'Limit of {maxFiles, plural, one {# file} other {# files}} reached',
		description: 'Label for the file upload button in the chat input when max files is set',
	},
} as const);
export default _default_1;
